/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { BASE_SENSING_SYSTEM_ARCHITECTURE_DESIGN_ENDPOINT, SENSING_SYSTEM_ARCHITECTURE_DESIGN_CONSTANTS } from "./constants"
import { Pages, RequestKeys, Requests } from "./types"


/** Forms the endpoint URL for Sensing System Architecture Design requests */
export const formRequestUrl = (page: Pages, request: Requests) => {
  return `${BASE_SENSING_SYSTEM_ARCHITECTURE_DESIGN_ENDPOINT}?${RequestKeys.PAGE}=${page}&${RequestKeys.REQUEST}=${request}`
}

/** Forms the View Study page URL for a given study ID */
export const formViewStudyUrl = (studyId: string) => {
  return `${SENSING_SYSTEM_ARCHITECTURE_DESIGN_CONSTANTS.viewStudy.route}?id=${studyId}`
}
